/*
 * Respuestas del staff de MU VANGUARD a los pendientes de la guía.
 * Se muestran como "Confirmado por administración" con su fecha. Son distintas de
 * "Confirmado por configuración" (archivos del 08/10/2026) y de "Comprobado dentro del juego".
 *
 * Cada respuesta confirma SOLO el dato de su `pendingKey`. Por ejemplo, la ubicación de Sebina
 * (npc-location:235) no confirma el Zen ni los requisitos de su misión.
 *
 * Formato de `pendingKey`: el mismo que muestra "Copiar todos los pendientes de la guía".
 */

export type AdminConfirmation = {
  pendingKey: string
  /** Respuesta tal como la dio la administración. */
  answer: string
  /** Fecha de la confirmación, AAAA-MM-DD. */
  date: string
  /** Datos estructurados cuando la respuesta es una ubicación. */
  location?: { mapName: string; x?: number; y?: number }
  /** Varias ubicaciones (p. ej. un NPC que se desplaza), con su condición. */
  locations?: { mapName: string; x?: number; y?: number }[]
  condition?: string
  by?: string
}

export const adminConfirmations: AdminConfirmation[] = []

export const adminConfirmation = (key: string) => adminConfirmations.find((c) => c.pendingKey === key)

export const formatAdminDate = (iso: string) => {
  const d = new Date(`${iso}T12:00:00`)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })
}
